import './ProductUpdates.css'
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import useLanguagePrefix from '../../LanguagePrefix';

function ProductUpdates() {
    const { t } = useTranslation();
    const langPrefix = useLanguagePrefix();

    return (
        <div>
            <Helmet>
                <title>Prostay – Product Updates & Feature Releases</title>
                <meta name="description" content="Track product development, version releases, and feature rollouts in our Prostay updates timeline. Stay in the loop as we grow." />
                <link rel="canonical" href={"https://www.prostay.com" + langPrefix + "/product-updates/"} />

                <link rel="alternate" href="https://www.prostay.com/en/product-updates/" />
                <link rel="alternate" href="https://www.prostay.com/es/product-updates/" />

                <meta property="og:title" content="Prostay – Product Updates & Feature Releases" />
                <meta property="og:description" content="Track product development, version releases, and feature rollouts in our Prostay updates timeline. Stay in the loop as we grow." />
                <meta property="og:type" content="website" />
                <meta property="og:url" content={"https://www.prostay.com" + langPrefix + "/product-updates/"} />
                <meta property="og:image" content='https://prostay.com/images/ogImage.png' />

                <meta property="og:site_name" content="Prostay" />

                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Prostay – Product Updates & Feature Releases" />
                <meta name="twitter:description" content="Track product development, version releases, and feature rollouts in our Prostay updates timeline. Stay in the loop as we grow." />
                <meta name="twitter:image" content='https://prostay.com/images/ogImage.png' />
                <meta name="twitter:site" content="@prostaypms" />
                <meta name="twitter:creator" content="@prostaypms" />

            </Helmet>
            <div className='product-updates'>
                <div className='background-image'>
                    <div className='background-image-start'>
                        <div className='mt-2 d-flex align-items-center gap-1 chip'>
                            {t('Resources')}
                        </div>
                        <div className='mt-2' style={{ maxWidth: '550px' }}>
                            <h1 style={{ margin: 0 }}>
                                {t('Product Updates')}
                            </h1>
                            <p className='mt-3 body-large'>
                                {t('Read about our developments through time from product updates to company milestones and more.')}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="timeline">
                    <div className='timeline-container'>
                        <div className="date date-position">{t('April 25')}
                            <div className='circle-position'>
                                <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="16.5" cy="16" r="8" fill="#1643E0" />
                                    <circle opacity="0.2" cx="16.5" cy="16" r="12" fill="#1643E0" />
                                    <circle opacity="0.1" cx="16.5" cy="16" r="16" fill="#1643E0" />
                                </svg>
                            </div>
                        </div>
                        <div className='left-position'>
                            <div class="first-event">
                                <div class="content">
                                    {/* <div className='title-text body-small'>{t('NEW FEATURE')}</div> */}
                                    <h5>{t('Product Development Kick-Off')}</h5>
                                    <p>{t('After months of planning, strategy, and concept validation, April 2nd marks the official kickoff of Prostay’s product development journey. Our goal was clear: to create a hospitality platform that solves real problems faced by hotels, resorts, and vacation rentals—by combining performance, flexibility, and modern design.')}</p>
                                    <p>{t('From day one, we committed to building Prostay as both a cloud-based and on-premise solution, with native apps for Windows, macOS, Android, and iPads. Development began on the foundational modules: Property Management System (PMS), Booking Engine, and Channel Manager. Our focus was not just speed, but precision—ensuring every feature aligned with the real needs of hospitality professionals.')}</p>
                                    {/*<button className='light-blue-filled-btn-small' style={{ width: 'fit-content' }}>
                                        {t('Learn more')}
                                        <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M19 8H1H19Z" fill="white" />
                                            <path d="M12 1L19 8M19 8L12 15M19 8H1" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button> */}
                                </div>
                            </div>
                        </div>
                        <div class="date-position-second">
                            <p className='date body-xsmall'>
                                {t('March 24')}
                            </p>
                            <svg className='circle-position-second' width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="8" cy="8" r="8" fill="#1643E0" />
                            </svg>
                        </div>
                        <div className='right-position'>
                            <div class="first-event">
                                <div class="content">
                                    {/*<div className='title-text'>{t('NEW FEATURE')}</div>*/}
                                    <h5>{t('First Product Launch')}</h5>
                                    <p>{t('After a year of intense development, iteration, and testing, we’re proud to announce the official launch of Prostay. This first public release introduces our fully integrated suite of hospitality tools, including the PMS, Booking Engine, Channel Manager, and our proprietary guest messaging platform, Prostay Nexus.')}</p>
                                    <p>{t('This launch represents more than just a software release—it marks the beginning of a new standard in hotel tech. Designed with direct feedback from operators, Prostay delivers a modern, modular system that adapts to properties of all sizes. From independent hotels to full-service resorts, we’re here to streamline operations, drive revenue, and elevate the guest experience—one feature at a time.')}</p>
                                    {/* <button className='light-blue-filled-btn-small' style={{ width: 'fit-content' }}>
                                        {t('Learn more')}
                                        <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M19 8H1H19Z" fill="white" />
                                            <path d="M12 1L19 8M19 8L12 15M19 8H1" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='d-flex align-items-center justify-content-center gap-2 mt-5'>
                    <button className='btn-blue-outline'>
                        {t('Load More')}
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2.66797 2.66666V5.99999H3.05597M3.05597 5.99999C3.49853 4.90541 4.29176 3.9886 5.31132 3.39323C6.33089 2.79787 7.51917 2.5576 8.68995 2.71009C9.86073 2.86257 10.9478 3.39919 11.7809 4.23584C12.6139 5.0725 13.1459 6.1619 13.2933 7.33333M3.05597 5.99999H6.0013M13.3346 13.3333V9.99999H12.9473M12.9473 9.99999C12.5041 11.0939 11.7107 12.01 10.6912 12.6049C9.67173 13.1997 8.48379 13.4397 7.31337 13.2872C6.14294 13.1348 5.0561 12.5986 4.22299 11.7625C3.38988 10.9264 2.85754 9.83762 2.7093 8.66666M12.9473 9.99999H10.0013" stroke="#1643E0" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </button>
                </div>
            </div>
        </div>
    );
}

export default ProductUpdates;